<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="60%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :serviceProvision="serviceProvision"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    executionOperation: Object,
    seedPlotOperation: Object,
    serviceProvision: Object,
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      // console.log(this.executionOperation, this.serviceProvision);
      if (this.executionOperation) {
        this.loadConsumedItemForExecutionOperation();
      } else if(this.seedPlotOperation){
        this.loadConsumedItemForSeedPlotOperation();
      } else {
        this.loadConsumedItemForServiceProvision();
      }
    },
    loadConsumedItemForExecutionOperation: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_CONSUMED_ITEM_FOR_EXECUTION_OPERATION_QUERY,
          variables: {
            operationTypeId: this.executionOperation.operationTypeId,
            periodIds: this.executionOperation.periodIdsAttribute
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          console.log("itens for executionOperation", response);
          this.entry = response.data.groundContext.exitConsumedItem;
          var arr = [];
          response.data.accountContext.availableItemsForConsumptionInExecutionOperation.forEach(item => {
             arr.push(item);
          });
          // console.log(arr);
          // console.log("ëntry", this.entry);
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadConsumedItemForSeedPlotOperation: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_CONSUMED_ITEM_FOR_SEED_PLOT_OPERATION_QUERY,
          variables: {
            operationTypeId: this.seedPlotOperation.operationTypeId,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("itens for executionOperation", response);
          this.entry = response.data.groundContext.exitConsumedItem;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadConsumedItemForServiceProvision: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_CONSUMED_ITEM_FOR_SERVICE_PROVISION_QUERY,
          variables: {
            serviceProvisionType: this.serviceProvision.type,
            serviceProvisionId: null
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("itens for serviceProvision", response);
          this.entry = response.data.groundContext.exitConsumedItem;
          this.extraData = response.data;          
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_CONSUMED_ITEM_FOR_EXECUTION_OPERATION_QUERY = gql `
  query($operationTypeId: ID!, $periodIds: [ID!]!) {
    groundContext {
      exitConsumedItem {
        id
        itemId
        item {
          id
          name          
          unit {
            id
            name
          }
          brand {
            id
            name
          }
        }
        packagingId
        packaging {
          id
          name
        }
        storageId
        storage {
          id
          name
        }
        quantity
        validations
      } 
    }
    accountContext {
      availableItemsForConsumptionInExecutionOperation(operationTypeId: $operationTypeId, periodIds: $periodIds) {
        id
        name        
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
        type
      }
    }
  }
`;

const NEW_CONSUMED_ITEM_FOR_SEED_PLOT_OPERATION_QUERY = gql `
  query($operationTypeId: ID!) {
    groundContext {
      exitConsumedItem {
        id
        itemId
        item {
          id
          name          
          unit {
            id
            name
          }
          brand {
            id
            name
          }
        }        
        packagingId
        trayId
        packaging {
          id
          name
          text
        }
        storageId
        storage {
          id
          name
        }
        hasCropLimit
        quantity
        unitQuantity
        validations
      } 
    }
    accountContext {
      availableItemsForConsumptionInSeedPlotOperation(operationTypeId: $operationTypeId) {
        id
        name        
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
        type
      }
    }
  }
`;

const NEW_CONSUMED_ITEM_FOR_SERVICE_PROVISION_QUERY = gql `
  query($serviceProvisionType: TypesEnum!, $serviceProvisionId: ID) {
    groundContext {
      exitConsumedItem {
        id
        itemId
        item {
          id
          name          
          unit {
            id
            name
          }
          brand {
            id
            name
          }
        }       
        packagingId
        packaging {
          id
          name
        }
        storageId
        storage {
          id
          name
        }
        quantity
        hasCropLimit
        validations
      } 
    }
    accountContext {
      availableItemsForConsumptionInServiceProvision(serviceProvisionType: $serviceProvisionType, serviceProvisionId: $serviceProvisionId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
        type
      }
    }
  }
`;

</script>

<style scoped></style>
